import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { createHashRouter, RouterProvider } from "react-router-dom";
import App from "./App";
import Error from "./pages/Error";
import Home from "./pages/Home";
import FirstPage from "./pages/FirstPage";
import ProductDetail from "./pages/ProductDetail";
import Search from "./pages/Search";
import store from "./store/store";
import "./styles.css";
import "bootstrap/dist/css/bootstrap.min.css";

import { LanguageProvider } from "./context/LanguageContext";
import { ThemeProvider } from "./context/ThemeContext";
// Ensure `id` (userCode) persists in URL and session across navigations/refreshes
const queryParams = new URLSearchParams(window.location.search);
let id = queryParams.get("id");
const storedUserCode = window.sessionStorage.getItem("userCode");

if (!id && storedUserCode) {
  id = storedUserCode;
  // Put it back to the URL without adding a new history entry
  queryParams.set("id", id);
  const newUrl = `${window.location.pathname}?${queryParams.toString()}`;
  window.history.replaceState(null, "", newUrl);
}

if (id) {
  try {
    window.sessionStorage.setItem("userCode", id);
  } catch {}
}
//const id = "MP405";
// const id = "MP393";

// const id = "MP348";
// const id = "MP356";

const router = createHashRouter([
  {
    path: "/",
    element: <App id={id} />,
    children: [
      {
        index: true,
        element: <FirstPage id={id} />,
      },
      {
        path: "home",
        element: <Home id={id} />,
      },

      {
        path: "product/:code",
        element: <ProductDetail id={id} />,
      },
      {
        path: "search",
        element: <Search id={id} />,
      },
    ],
    errorElement: <Error />,
  },
]);

const container = document.getElementById("root");
const root = createRoot(container);

if (!id) {
  root.render(
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column',
      fontFamily: 'sans-serif', textAlign: 'center', padding: 24
    }}>
      <h2>Bağlantı eksik</h2>
      <p>Bu sayfayı QR kod üzerinden veya geçerli bir bağlantı ile açın.</p>
    </div>
  );
} else {
  root.render(
    <ThemeProvider userCode={id}>
      <LanguageProvider>
        <Provider store={store}>
          <RouterProvider router={router} />
        </Provider>
      </LanguageProvider>
    </ThemeProvider>
  );
}
